// extracted by mini-css-extract-plugin
module.exports = {"container":"Date_container__1LTim"};